import { render, staticRenderFns } from "./ComplaintGeneralInfo.vue?vue&type=template&id=5489b998&"
import script from "./ComplaintGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./ComplaintGeneralInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports